import { motion } from "framer-motion";
import { Typewriter } from "./Reveal";

export default function PageHero({ eyebrow, title, img, children }) {
  return (
    <section className="relative pt-40 pb-20 sm:pt-48 sm:pb-28 overflow-hidden grain" data-testid="page-hero">
      {img && (
        <motion.img src={img} alt="" initial={{ scale: 1.2, opacity: 0 }} animate={{ scale: 1, opacity: 0.35 }} transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }} className="absolute inset-0 w-full h-full object-cover" />
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B0F12]/40 via-[#0B0F12]/70 to-[#0B0F12]" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <motion.p initial={{ opacity: 0, x: -40 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.2 }} className="text-xs uppercase tracking-[0.35em] text-[#00C9B7] font-semibold mb-5">{eyebrow}</motion.p>
        <Typewriter as="h1" className="font-display uppercase text-4xl sm:text-5xl lg:text-7xl leading-[1.05] max-w-4xl" data-testid="page-title">{title}</Typewriter>
        {children && <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6 }} className="mt-8">{children}</motion.div>}
      </div>
    </section>
  );
}
